<app-global-style-loader *ifPlatform="'server'"></app-global-style-loader>
<!--<app-simple-login *ngIf="!isLoggedIn" (onLogin)="onLogin(true)"></app-simple-login>-->
<div *ngIf="isPopupVisible" class="modal-backdrop has-pos-fix full-height full-width"></div>
<div [class.remove-full-height]="removeFullHeight || activeViewMode === ViewMode.GALLERY" class="app-container is-flex has-pos-rel" [class.has-side-nav]="showLeftNav || showRightNav" [@flipState]="flip" #appContainer (@flipState.done)="animationCallback($event)">
  <app-error></app-error>
  <app-side-nav [class.is-menu]="showLeftNav" [showLeftNav]="showLeftNav && !showRightNav" [showRightNav]="showRightNav && !showLeftNav" (changeRoute)="onRouteChange()"></app-side-nav>
  <app-header [currentPage]="currentPage" [currentShownListingType]="currentShownListingType" *ngIf="!concealHeader"></app-header>
  <div class="main-content is-flex flex-one is-flex-column has-pos-rel" [class.unpadded]="removePadding">
    <router-outlet></router-outlet>
    <router-outlet name="popup"
                   (activate)="onShowPopup($event)"
                   (deactivate)="onHidePopup($event)"
    ></router-outlet>
    <div class="search has-pos-abs full-width" *ngIf="showSearch">
      <app-search-bar
        [showBackButton]="true"
        [showAdditionalActionsButtons]="true"
        [shouldShowFiltersAfterSearching]="true"
        [showResultsOnInit]="true"
        [canHideSearchResults]="false"
        [focus]="true"
      ></app-search-bar>
    </div>
  </div>
  <div *ngIf="!concealFooter" class="is-flex flex-one is-flex-column has-pos-rel" [class.unpadded]="removePadding">
    <app-cms-links [hidden]="concealFooter" [showNew]="true"></app-cms-links>
  </div>
  <app-footer *ngIf="!concealFooter"  [screenSize]="screenSize" [currentShownListingType]="currentShownListingType" [provinces]="provinces"></app-footer>
  <app-drawer [currentShownListingType]="currentShownListingType" class="main-drawer" #drawer></app-drawer>
  <app-login [loginSource]="loginSource" *ngIf="showSignIn"></app-login>
  <app-quebec-modal *ngIf="showQuebecModal" [showModal]="showQuebecModal"></app-quebec-modal>
</div>
